import { ApplicantStatus, ApplicationStatus } from '../graphql/queries';

export const APPLICATION_STATUS_LABELS = {
  [ApplicationStatus.started]: 'In progress',
  [ApplicationStatus.invited_and_started]: 'In progress',
  [ApplicationStatus.withdrawn]: 'Withdrawn',
  [ApplicationStatus.declined]: 'Declined',
  [ApplicationStatus.approved]: 'Approved',
  [ApplicationStatus.submitted]: 'Applied',
  [ApplicationStatus.partially_submitted]: 'In progress',
  [ApplicationStatus.conditionally_approved]: 'Conditionally approved',
};

export const APPLICANT_STATUS_LABELS = {
  [ApplicantStatus.pending]: 'In progress',
  [ApplicantStatus.completed]: 'Applied',
  [ApplicantStatus.withdrawn]: 'Withdrawn',
};

export const APPLICANT_SUBMISSION_STATUS_TYPES = {
  REQUIREMENTS_MET: 'REQUIREMENTS_MET',
  REQUIREMENTS_INCOMPLETE: 'REQUIREMENTS_INCOMPLETE',
  REQUIREMENTS_INCOMPLETE_BECAUSE_PAST_JOBS: 'REQUIREMENTS_INCOMPLETE_BECAUSE_PAST_JOBS',
  REQUIREMENTS_EMPTY: 'REQUIREMENTS_EMPTY',
  REQUIREMENTS_EXPIRED: 'REQUIREMENTS_EXPIRED',
} as const;

export type ApplicationSubmissionStatus =
  (typeof APPLICANT_SUBMISSION_STATUS_TYPES)[keyof typeof APPLICANT_SUBMISSION_STATUS_TYPES];

export const NON_EDITABLE_APPLICATION_STATUSES = new Set([ApplicationStatus.approved, ApplicationStatus.declined]);
export const NON_EDITABLE_APPLICANT_STATUSES = new Set([ApplicantStatus.completed, ApplicantStatus.withdrawn]);
